import { useMemo } from "react";
import { useQuery } from "@apollo/client";

const NO_PERMISSION_MESSAGE =
  "You do not have permission to perform this action";

export default function useExecuteQuery(
  query,
  {
    dataMapper = (data) => data,
    pollInterval = null,
    queryOptions = {},
    variables = {},
    ignoreNoPermission = false,
  } = {},
) {
  const { loading, error, data, stopPolling, refetch, fetchMore } = useQuery(
    query,
    {
      pollInterval,
      variables,
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
      errorPolicy: ignoreNoPermission ? "all" : "none",
      ...queryOptions,
    },
  );

  const preparedData = useMemo(() => {
    if (!data) {
      return data;
    }
    try {
      return dataMapper(data);
      // eslint-disable-next-line no-unused-vars
    } catch (error) {
      return undefined;
    }
  }, [data]);

  const errors = useMemo(() => {
    if (!error) {
      return null;
    }

    if (error.networkError) {
      stopPolling();
      return {
        title: error.networkError.name,
        subTitle: error.networkError.message,
      };
    }

    if (error.graphQLErrors) {
      const [title, subTitle] = error.graphQLErrors[0].message.split(":");
      if (ignoreNoPermission && title === NO_PERMISSION_MESSAGE) return null;
      return {
        title,
        subTitle,
      };
    }
  }, [error]);

  return { data: preparedData, errors, loading, refetch, fetchMore };
}
